import { render, staticRenderFns } from "./ImageOverlay.vue?vue&type=template&id=0023e65e&scoped=true&"
import script from "./ImageOverlay.vue?vue&type=script&lang=js&"
export * from "./ImageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ImageOverlay.vue?vue&type=style&index=0&id=0023e65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023e65e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0023e65e')) {
      api.createRecord('0023e65e', component.options)
    } else {
      api.reload('0023e65e', component.options)
    }
    module.hot.accept("./ImageOverlay.vue?vue&type=template&id=0023e65e&scoped=true&", function () {
      api.rerender('0023e65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/images/ImageOverlay.vue"
export default component.exports